import 'bootstrap/dist/css/bootstrap.min.css';

import '../Home/Home.css'
import './About.css';

import React from 'react';

import Header from "../Header/Header"

function About() {
  return (
    <React.Fragment>

      <Header />

      <div className="section">
        <div className="content-container container-sm">

          <h4 className="text section-heading">About Gayathri Ram Mohan</h4>
          <p className="text" style={{ color: 'var(--color-text-light)', marginTop: '1rem' }}>
            Licensed Clinical Social Worker MSW, MA (Holistic Counseling Psychology)
          </p>

          <div className="section-divider" style={{ margin: '2rem 0' }}></div>

          <p className="text">
            Welcome! I'm a Licensed Clinical Social Worker (LCSW #102168) with over two decades of experience supporting people of all ages and backgrounds. Having worked in both India and the U.S., I bring a cross-cultural perspective to mental health and healing, honoring the diverse ways people experience and recover from life's challenges.
          </p>

          <p className="text">
            I am a trauma-informed therapist, trained in EMDR (EMDRIA) and certified as a mindfulness trainer and practitioner. I also facilitate Interpersonal Dynamics ("T-groups") at the Stanford Graduate School of Business, where I guide students in building self-awareness and authentic connections. In addition, I serve as a resource for Narika, a nonprofit that supports survivors of intimate partner violence. I am also one of the supervisors and master process trainers in the Mirror Program, where I provide therapist-trainees and associates with supportive, informative supervision and behind-the-mirror guidance.
          </p>

          <p className="text">
            My approach is compassionate and wholehearted. I draw from somatic, experiential, and mindfulness-based practices to create a safe space for healing and growth. Whether you're seeking support for yourself, your relationship, or your family, I offer therapy both in person and online to meet your needs.
          </p>

          <h5 className="text" style={{ marginTop: '2rem', color: 'var(--color-primary-dark)' }}>Groups I Have Facilitated</h5>
          <p className="text">
            In addition to individual and family therapy, I love working in group settings where people can connect, heal, and learn together. Over the years, I've facilitated:
          </p>

          <ul className="about-list">
            <li className="text">Interpersonal Dynamics ("T-groups") for MBA students at Stanford Graduate School of Business</li>
            <li className="text">Grief support groups</li>
            <li className="text">Anger and shame process groups</li>
            <li className="text">Caregiver support groups</li>
            <li className="text">Mindfulness groups</li>
            <li className="text">Basic Process training groups at Process Therapy Institute</li>
          </ul>

          <p className="text" style={{ marginTop: '1.5rem' }}>
            I offer individual, couples and family therapy both in person and virtual.
          </p>

          <div className="adaptiveEducation">
            <div>
              <h4 className="text">Education</h4>

              <h6 className="text">John F Kennedy University, 2016</h6>
              <p className="text bold">MA in Counseling Psychology</p>

              <h6 className="text">Tata Institute of Social Science, 1988</h6>
              <p className="text bold">MSW in Family and Child Welfare</p>

              <h6 className="text">University of Bombay, 1986</h6>
              <p className="text bold">BA in Economics</p>
            </div>
            <div>
              <h4 className="text">Training</h4>
              <div>
                <h6 className="text">EMDR (Eye Movement Desensitization and Reprocessing)</h6>
                <h6 className="text">Interpersonal Dynamics Facilitator</h6>
                <h6 className="text">Mindfulness Teacher Certified</h6>
              </div>
            </div>
          </div>
        </div>

      </div>
    </React.Fragment>
  );
}

export default About;
